import * as React from "react";

import {
  Box,
  Button,
  Flex,
  HStack,
  Heading,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";

import { ProudLogo } from "../../atoms/Logo/ProudLogo";

import proudXs from "../../../images/PROUD_xs.webp";
import proudSm from "../../../images/PROUD_sm.webp";
import proudMd from "../../../images/PROUD_md.webp";
import proudLg from "../../../images/PROUD_lg.webp";
import proudXl from "../../../images/PROUD_xl.webp";
import proud2Xl from "../../../images/PROUD_2xl.webp";
import proud3Xl from "../../../images/PROUD_3xl.webp";

export const Proud = () => {
  return (
    <Stack
      direction={{ base: "column", md: "row" }}
      display={"flex"}
      justifyContent={{ base: "flex-end", md: "center" }}
    >
      <Box w="full">
        <Stack
          spacing={8}
          w={"full"}
          pos="relative"
          maxW="auto"
          minH={{ base: "100vh", md: "577px" }}
          justifyContent={{ base: "flex-end", md: "center" }}
          bgImg={{
            base: `url(${proudXs})`,
            sm: `url(${proudSm})`,
            md: `url(${proudMd})`,
            lg: `url(${proudLg})`,
            xl: `url(${proudXl})`,
            "2xl": `url(${proud2Xl})`,
            "3xl": `url(${proud3Xl})`,
          }}
          bgPos={"center"}
          bgSize="cover"
        >
          <Link href="/get-involved" _hover={{ textDecortaion: "none" }}>
            <Button
              bg={"#D9A542"}
              aria-label="get-involved"
              color={"white"}
              textTransform={"uppercase"}
              borderRadius={0}
              pos={"absolute"}
              top={{ base: "45%", md: "65%" }}
              left={{ base: "0", md: "19%" }}
              w={{ base: "343px", md: "auto" }}
              mx={4}
              gap="8px"
              fontWeight={"700"}
              _hover={{
                bg: "#D9A542",
              }}
            >
              Get Involved
            </Button>
          </Link>
          <HStack
            mx={{ base: "4", md: "auto" }}
            bg="#49a3cb"
            fontSize={"xl"}
            pos={{ base: "relative", md: "absolute" }}
            top={{ base: "12", md: "auto" }}
            bottom={{ base: "0", md: "36" }}
            right={{ base: "0", md: "16" }}
            zIndex="999"
            p={{ base: "4", md: "8" }}
            gap={8}
            color="white"
            flexDir={{ base: "column", md: "row" }}
            alignItems={{ base: "flex-start", md: "center" }}
          >
            <Link
              href="https://www.guidestar.org/profile/shared/47fac535-417c-4426-b47e-156b1036cb04"
              target="_blank"
            >
              <ProudLogo pos="relative" w="130px" h="130px" overflow="hidden" />
            </Link>
            <Text
              textTransform={"uppercase"}
              display={"flex"}
              fontWeight={"700"}
              fontSize={{ base: "lg", md: "20px" }}
              lineHeight={"150%"}
              alignItems={"center"}
              w={{ base: "100%", md: "350px" }}
            >
              this organization is a platinum-level guidestar participant,
              demonstrating its commitment to transparency.
            </Text>
          </HStack>
        </Stack>
      </Box>
    </Stack>
  );
};
